"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERIFICATION_STATUS = void 0;
var VERIFICATION_STATUS;
(function (VERIFICATION_STATUS) {
    VERIFICATION_STATUS[VERIFICATION_STATUS["NOT_SIGNED"] = 0] = "NOT_SIGNED";
    VERIFICATION_STATUS[VERIFICATION_STATUS["SIGNED_AND_VALID"] = 1] = "SIGNED_AND_VALID";
    VERIFICATION_STATUS[VERIFICATION_STATUS["SIGNED_AND_INVALID"] = 2] = "SIGNED_AND_INVALID";
})(VERIFICATION_STATUS || (exports.VERIFICATION_STATUS = VERIFICATION_STATUS = {}));
//# sourceMappingURL=interface.js.map